import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { SEGMENTS } from "../lib/data";

const Icon = ({ name, className }) => { const C = Icons[name] || Icons.Circle; return <C className={className} />; };

export default function Businesses() {
  return (
    <div data-testid="businesses-page" className="pt-28 pb-20 bg-cream-100 text-soil-700 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading as="h1" overline="Our Businesses" title="The Genesis Ecosystem" subtitle="Ten verticals, one vision. Click any business to explore its products, models and opportunities." />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SEGMENTS.map((s, i) => (
            <motion.div key={s.slug} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.45, delay: (i % 3) * 0.07 }}>
              <Link to={`/businesses/${s.slug}`} data-testid={`business-list-${s.slug}`} className="group block h-full rounded-2xl overflow-hidden card-cream hover:border-forest-500/40 transition-all hover:-translate-y-1">
                <div className="relative h-44 overflow-hidden">
                  <img loading="lazy" decoding="async" src={s.img} alt={s.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest-800/70 to-transparent" />
                  {s.star && <span className="absolute top-3 right-3 text-[10px] font-bold px-2 py-1 rounded-full forest-gradient text-cream-50">★ STAR</span>}
                  {s.upcoming && <span className="absolute top-3 right-3 text-[10px] font-bold px-2 py-1 rounded-full bg-white/20 text-forest-800">UPCOMING</span>}
                  <div className="absolute bottom-3 left-4 w-11 h-11 rounded-xl gold-gradient flex items-center justify-center"><Icon name={s.icon} className="w-5 h-5 text-cream-50" /></div>
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-lg font-semibold text-forest-800 group-hover:text-terracotta-600 transition-colors">{s.name}</h3>
                  <p className="text-terracotta-600 text-xs font-medium mt-0.5">{s.tagline}</p>
                  <p className="text-soil-500 text-sm mt-2 line-clamp-2">{s.intro}</p>
                  <div className="flex items-center gap-1.5 text-terracotta-600 text-sm font-semibold mt-4">Enter business <Icons.ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
